/**
 * @file index.tsx
 *
 * @fileoverview Renders button which copy job detail link to the clipboard.
 */

import { Button } from '~/vcl/atoms/01-forms/01-button';
import { SharingButtonProps } from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  analyticsDispatch,
  DIMENSIONS,
  EVENTS,
  setEventParams,
} from '~/jobiqo/lib/analytics';
import { getJobDimensions } from '~/jobiqo/components/Job/utils/job_analytics';

export const CopyButton = ({
  url,
  sharingEntity,
  sharingEntityType,
}: SharingButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
    if (url && sharingEntity && sharingEntityType) {
      const shareMethod = setEventParams({ [DIMENSIONS.share_method]: 'copy' });
      switch (sharingEntityType) {
        case 'job':
          const jobDimensions = getJobDimensions(sharingEntity);
          analyticsDispatch(EVENTS.JOB_SHARE, {
            ...jobDimensions,
            ...shareMethod,
          });
          break;
        default:
          break;
      }
    }
  };

  return (
    <Button buttonStyle="primary" bordered={true} onClick={handleCopy}>
      {isCopied ? (
        <FormattedMessage
          id="social_media_sharing_buttons_copied"
          defaultMessage="Link copied"
        />
      ) : (
        <FormattedMessage
          id="social_media_sharing_buttons_copy"
          defaultMessage="Copy link"
        />
      )}
    </Button>
  );
};

export default CopyButton;
